import React from "react";
import slugify from "slugify";
import { Container } from "react-bootstrap";
import { FaFacebookF, FaYoutube, FaLinkedinIn } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { HashLink } from "react-router-hash-link";

import logo from "../../assets/images/logo-white.png";
import "./Footer.scss";

const Footer = () => {
  const socialList = [
    {
      icon: FaFacebookF,
      link: "https://www.facebook.com/SociedadePontoVerde?ref=br_rs",
      name: "facebook",
    },
    {
      icon: FaYoutube,
      link: "https://www.youtube.com/SociedadePontoVerdeOficial",
      name: "youtube",
    },
    {
      icon: FaLinkedinIn,
      link: "https://www.linkedin.com/company/sociedade-ponto-verde/",
      name: "linkedin",
    },
    {
      icon: RiInstagramFill,
      link: "https://www.instagram.com/pontoverde.pt/",
      name: "instagram",
    },
  ];

  const listWebsite = ["Lisbon map", "Why recycle?", "Areas"];
  const listContact = ["About us", "Donate"];
  return (
    <div className="app-footer">
      <Container>
        <div className="media">
          <div className="logo">
            <img src={logo} alt="logo" />
          </div>
          <div className="social">
            {socialList.map((item, i) => (
              <a
                className={`icon ${item.name}`}
                key={i}
                href={item.link}
                target="_blank"
              >
                <item.icon />
              </a>
            ))}
          </div>
        </div>
        <div className="website list">
          <span>Links</span>
          <ul>
            {listWebsite.map((item, i) => (
              <li key={item + i}>
                <HashLink smooth to={`/#${slugify(item).toLowerCase()}`}>
                  <div className="icon">
                    <MdKeyboardDoubleArrowRight />
                  </div>
                  {item}
                </HashLink>
              </li>
            ))}
          </ul>
        </div>
        <div className="contact list">
          <span>Contact</span>
          <ul>
            {listContact.map((item, i) => (
              <li key={item + i}>
                <a href={`#${slugify(item).toLowerCase()}`}>
                  {" "}
                  <div className="icon">
                    <MdKeyboardDoubleArrowRight />
                  </div>
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="subscribe">
          <span>Subscribe to our email service</span>
          <div className="form">
            <input type="email" placeholder="Your email" />
            <button>Subscribe</button>
          </div>
        </div>
      </Container>
      <span className="copyright">Copyright 2024 Sociedade Ponto Verde</span>
    </div>
  );
};

export default Footer;
